import { useUserSettings } from "./useUserSettings";
import correctSound from "../assets/correct_sound.wav";

/**
 * Hook for playing the correct sound that respects user settings
 */
export const useSound = () => {
  const { settings } = useUserSettings();

  /**
   * Play the correct sound if sound effects are enabled
   */
  const playCorrectSound = () => {
    // Skip if sound is disabled or special user
    if (settings?.isSoundEffectsEnabled === false) {
      return;
    }

    try {
      const audio = new Audio(correctSound);
      audio.volume = 0.5;
      audio.play().catch((error) => {
        console.error("Error playing sound:", error);
      });
    } catch (error) {
      console.error("Error creating audio:", error);
    }
  };

  return { playCorrectSound };
};
